import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SyncSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SyncSVG;
